<template>
  <div class="card relative z-2" style="">
    <Menubar :model="(items.concat(privacyItems as []) as MenuItem[])">
      <template #start>
        <a href="/" style="margin-right:1em;"><img alt="Dragonfly Massage" src="@/assets/logo.svg" height="44" class="mr-2" /></a>
      </template>
      <template #item="{ label, item, props, root }">
        <router-link v-if="item.route" v-slot="routerProps" :to="item.route" custom>
          <a :href="routerProps.href" v-bind="props.action">
            <span v-bind="props.icon" />
            <span v-bind="props.label">{{ label }}</span>
          </a>
        </router-link>
        <a v-else :href="item.url" :target="item.target" v-bind="props.action">
          <span v-bind="props.icon" />
          <span v-bind="props.label">{{ label }}</span>
          <span :class="[root ? 'pi pi-fw pi-angle-down' : 'pi pi-fw pi-angle-right']" v-bind="props.submenuicon" />
        </a>
      </template>
    </Menubar>
    
      <router-view />
      <div style="max-width: 100em;width:95%;">
      <footer>
        <br><br>
        <hr>
        <i>Every body is unique and worthy of special treatment!</i>
        <p>
          <a target="_blank" rel="noopener"
            href="https://search.google.com/local/writereview?placeid=ChIJa3wQ4m5lz4cRI79yEvBpS-w">
            <i class="pi pi-star" aria-hidden="true"></i> Enjoyed your session? Leave a review on Google
          </a>
        </p>

      </footer>
    </div>
  </div>
</template>

<script lang="ts">
export default {
  name: 'app',
  data() {
    return {
      privacyItems: [
        {
          label: 'Privacy & Terms of Service',
          route: '/privacy'
        }
      ],

      items: [
        {
          label: 'Home',
          route: '/'
        },
        {
          label: 'Services',
          route: '/services'
        },
        {
          label: 'Corporate',
          route: '/corporate'
        },
        {
          label: 'Pricing',
          route: '/pricing'
        },
        {
          label: 'Gift Cards',
          route: '/gift-cards'
        },
        {
          label: 'About',
          route: '/about_us'
        },
        {
          label: 'FAQ',
          route: '/faq'
        },
      ]
    }
  }
}
</script>

<script lang="ts" setup>
import Menubar from 'primevue/menubar';
import 'primeicons/primeicons.css';
import { MenuItem } from 'primevue/menuitem';
</script>
